import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getFilteredMealsWithSort, ClearMeal } from '../../redux/actions/meals';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { Loader } from '../../components/utils';
import { getAllCategorys } from '../../redux/actions/category';
import { DataGrid } from '@mui/x-data-grid';
import {
  DeletButtonStyle,
  DeleteonBlur,
  DeleteonFocus,
  DeleteonMouseEnter,
  DeleteonMouseLeave,
  EditButtonStyle,
  EditonBlur,
  EditonFocus,
  EditonMouseEnter,
  EditonMouseLeave,
  localeTextGrid,
} from "../../constants";
import { ThemeProvider, createTheme } from '@mui/material';
import { useStateContext } from '../../context/ContextProvider';
import { BaseUrl, media } from '../../server';
import { Spiner } from '../utils/Form';
import { truncateTitle } from "../../middleware/truncateTitle";
import { truncateText, renderText } from "../hooks/TextVeiw";
import { Button } from "@mui/material";
import axios from "axios";
import MealsFilter from '../../components/MealsFilter';

function DAllMeals() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentDir } = useStateContext();
  const navigate = useNavigate();
  
  // States
  const [isSpinner, setIsSpinner] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });

  const [filters, setFilters] = useState({
    search: '',
    categoryId: '',
    priceMin: '',
    priceMax: '',
    sortBy: 'default'
  });

  const page = paginationModel.page;
  const limit = paginationModel.pageSize;

  // ✅ نفس الـ action والـ state كما في AllResturentMeals
  const { isLoading, FilltermealsWithSort, FilterpaginationWithSort } = useSelector((state) => state.Meals);
  const { AllCategorys } = useSelector((state) => state.Categorys);

  // ✅ نفس طريقة الاستدعاء
  useEffect(() => {
    dispatch(getFilteredMealsWithSort(page, limit, filters));
  }, [page, limit, filters, dispatch]);

  useEffect(() => {
    dispatch(getAllCategorys());
  }, [dispatch]);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setPaginationModel(prev => ({ ...prev, page: 0 }));
  };

  const deletemealHandel = async (id) => {
    setIsSpinner(true);
    try {
      const { data } = await axios.delete(`${BaseUrl}/blogs/${id}`, { withCredentials: true });
      if (data.success) {
        toast.success(<span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">{t("Meal deleted successfully!")}</span>);
        dispatch(getFilteredMealsWithSort(page, limit, filters));
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      setIsSpinner(false);
    }
  };

  const UpdatemealHandeler = (id) => {
    dispatch(ClearMeal());
    navigate(`/EditmealPage/${id}`);
  };

  const theme = createTheme({
    direction: currentDir
  });

  const columns = [
    {
      field: 'titleAr',
      headerName: t('Title (Ar)'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center pt-4">
          <p className="font-medium text-sm font-kufi">{truncateTitle(params.value, 3)}</p>
        </div>
      )
    },
    {
      field: 'titleEn',
      headerName: t('Title (En)'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 200,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center pt-4">
          <p className="font-medium text-sm font-kufi">{truncateTitle(params.value, 3)}</p>
        </div>
      )
    },
    {
      field: 'textAr',
      headerName: t('Text (Ar)'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 250,
      filterable: false,
      renderCell: (params) => (
        <div className="flex font-medium text-sm font-kufi items-center pt-4">
          {renderText(truncateText(params.value, 4), "font-medium text-sm font-kufi items-center")}
        </div>
      )
    },
    {
      field: 'textEn',
      headerName: t('Text (En)'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 250,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center pt-4">
          <p className="font-medium text-sm font-kufi">
            {renderText(truncateText(params.value, 4), "font-medium text-sm font-kufi items-center")}
          </p>
        </div>
      )
    },
    {
      field: 'price',
      headerName: t('price'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 120,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center pt-4">
          <p className="font-medium text-sm font-kufi">{params.value} جنية</p>
        </div>
      )
    },
    {
      field: 'Image',
      headerName: t('Image'),
      headerClassName: 'font-semibold text-sm font-kufi',
      minWidth: 100,
      flex: 0.7,
      filterable: false,
      renderCell: (params) => (
        <div style={{
          borderRadius: "10%",
          padding: "2px",
          width: "50px",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50px"
        }}>
          <img
            src={`${media}${params.value}`}
            alt="Product Image"
            style={{
              height: "100%",
              width: "auto",
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "cover",
              borderRadius: "50%",
            }}
          />
        </div>
      ),
    },
    {
      field: 'actions',
      headerName: t('Actions'),
      headerClassName: 'font-semibold text-sm font-kufi',
      width: 150,
      filterable: false,
      renderCell: (params) => (
        <div className="flex pt-2 w-[150px] gap-2 items-center">
          <Button 
            className="rounded-full"
            style={DeletButtonStyle}
            onMouseEnter={DeleteonMouseEnter}
            onMouseLeave={DeleteonMouseLeave}
            onFocus={DeleteonFocus}
            onBlur={DeleteonBlur}
            onClick={() => deletemealHandel(params.row._id)}
          >
            {isSpinner ? <Spiner fillColor={"fill-gray-300"} /> : <span className="body-2">{t("Delete")}</span>}
          </Button>
          <Button 
            className="rounded-full"
            style={EditButtonStyle}
            onMouseEnter={EditonMouseEnter}
            onMouseLeave={EditonMouseLeave}
            onFocus={EditonFocus}
            onBlur={EditonBlur}
            onClick={() => UpdatemealHandeler(params.row._id)}
          >
            <span className='body-2'>{t("Edit")}</span>
          </Button>
        </div>
      )
    },
  ];

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex-col lg:p-16 py-14 px-5 w-full items-start">
          <h2 className="h2 text-color-1 text-center dark:text-tcolor-1 mb-4 md:mb-8">
            {t("All Meals")}
          </h2>

          {/* ✅ نفس الفلتر بالضبط */}
          <MealsFilter 
            onFilterChange={handleFilterChange}
            categories={AllCategorys}
            initialFilters={filters}
          />

          <div className="items-center relative justify-center md:m-10 mt-24 p-2 md:p-10 h-auto bg-white rounded-3xl">
            <ThemeProvider theme={theme}>
              <div style={{ width: '100%', overflowX: 'auto' }}>
                <DataGrid
                  rows={FilltermealsWithSort}
                  columns={columns}
                  disableRowSelectionOnClick
                  disableColumnSelector
                  sx={{ minWidth: '1350px' }}
                  pagination
                  paginationMode="server"
                  rowCount={FilterpaginationWithSort?.totalItems || 0}
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  pageSizeOptions={[paginationModel.pageSize]}
                  getRowId={(row) => row._id}
                  localeText={localeTextGrid}
                />
              </div>
            </ThemeProvider>
          </div>
        </div>
      )}
    </>
  );
}

export default DAllMeals;